//Imports
import React, { useCallback, useEffect } from "react";

//Controls
import { Button, Modal } from "@gpstrackit/gtc-react-controls";

//Components
import {
    NotificationManager,
    NotificationContainer,
} from "Components/Notifications";

//Hooks
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

//Actions
import { manageDeleteManageWorkOrderStatus, reset } from "./redux/slice";

const DeleteManageWorkOrderStatus = ({ refresh }) => {

    //Redux
    const dispatch = useDispatch();
    const { open, loading, result, error, workOrderStatus, workOrderStatusList } = useSelector((state) => state.manageDeleteManageWorkOrderStatusRedux);

    //Language
    const { messages } = useIntl();

    //Handlers and utils
    const handleClose = useCallback(() => dispatch(reset()), []);

    const handleDeleteSubmit = useCallback(() => {
        if (workOrderStatus) {
            dispatch(manageDeleteManageWorkOrderStatus({ ids: [workOrderStatus?.id] }));
        }
        if (workOrderStatusList?.length) {
            dispatch(manageDeleteManageWorkOrderStatus({ ids: workOrderStatusList.map((item) => item?.id) }));
        }
    }, [workOrderStatus, workOrderStatusList]);

    //Effects
    useEffect(() => {
        if (!error) return;
        NotificationManager.error(
            error?.error || messages["errorMessage"],
            messages["error"],
            3000,
            null,
            null,
            "error"
        );
        dispatch(reset({ error: null }));
    }, [error]);

    useEffect(() => {
        if (!result) return;
        if (result?.delete) {
            const messageSuccess = workOrderStatus
                ? messages['manage_deleteWorkOrderStatus_successMessage']
                : messages['manage_deleteWorkOrderStatuses_successMessage'];

            NotificationManager.success(
                messageSuccess,
                messages["success"],
                3000,
                null,
                null,
                "success"
            );
            refresh();
            dispatch(reset());
        } else {
            NotificationManager.error(
                messages["errorMessage"],
                messages["error"],
                3000,
                null,
                null,
                "error"
            );
            dispatch(reset({ result: null }));
        }
    }, [result]);

    return (
        <Modal
            title={
                workOrderStatus
                    ? messages['manage_deleteWorkOrderStatus_title']
                    : messages['manage_deleteWorkOrderStatuses_title']
            }
            size="small"
            open={open}
            handleClose={handleClose}
            loading={loading}
            footer={
                <div>
                    <Button
                        variant="secondary"
                        style={{ marginRight: "5px" }}
                        onClick={() => handleClose()}
                        isDisabled={loading}
                    >
                        {messages["cancel"]}
                    </Button>
                    <Button
                        variant="warning"
                        onClick={() => handleDeleteSubmit()}
                        isDisabled={loading}
                    >
                        {messages["delete"]}
                    </Button>
                </div>
            }
        >
            <div style={{ padding: "10px 25px" }}>
                <p>{workOrderStatus ? messages['manage_deleteWorkOrderStatus_description'] : messages['manage_deleteWorkOrderStatuses_description']}</p>
                <ul>
                    {workOrderStatus ? (
                        <li>
                            {workOrderStatus?.name}
                        </li>
                    ) : (
                        workOrderStatusList?.map((crew, index) => (
                            <li key={index}>
                                {crew.name}
                            </li>
                        ))
                    )}
                </ul>
            </div>
            <NotificationContainer />
        </Modal>
    );
};

export default DeleteManageWorkOrderStatus;